import APIClient from './axios.util';

const demosApi = {
    // GET /api/demos/ — returns grouped [{app, demos:[{id, title, url, description}]}]
    // API returns paginated flat items; we fetch with high limit and group by app here
    getCatalog: async () => {
        const res = await APIClient.get('/demos/', { params: { limit: 100 } });
        const items = res.data?.data?.items ?? [];
        const grouped = Object.values(
            items.reduce((acc, item) => {
                if (!acc[item.app]) acc[item.app] = { app: item.app, demos: [] };
                acc[item.app].demos.push({
                    id: item.id,
                    title: item.title,
                    url: item.url,
                    description: item.description,
                    is_active: item.is_active,
                });
                return acc;
            }, {})
        );
        return { ...res, data: grouped };
    },

    // GET /api/demos/my-access — wrapped {success, data:[{id, app, title, url, description, is_active}]}
    getMyAccess: () => APIClient.get('/demos/my-access'),

    // GET /api/demos/my-request — wrapped {success, data:{request_id, requested_demo_ids:[int], ...}}
    getMyRequest: () => APIClient.get('/demos/my-request'),

    // POST /api/demos/request — body: {requested_demo_ids: [1,2,3]}
    requestAccess: (demoIds) => APIClient.post('/demos/request', { requested_demo_ids: demoIds }),

    // GET /api/demos/countries — {countries: [...]}
    getCountries: () => APIClient.get('/demos/countries'),

    // GET /api/demos/timezones/:country — {country, timezones: [...]}
    getTimezones: (country) => APIClient.get(`/demos/timezones/${encodeURIComponent(country)}`),

    // POST /api/demos/schedule
    scheduleDemo: (payload) => APIClient.post('/demos/schedule', payload),
};

export default demosApi;
